module.exports = __webpack_public_path__ + "assets/character-icon-3.cda56763.svg";